export const env = {
    apiUrl: process.env.REACT_APP_API_URL || '/api/v1',
    production: process.env.REACT_APP_PRODUCTION === 'true',
    reactAppSocketUrl: process.env.REACT_APP_SOCKET_URL || 'https://api.app.muvin.it',
    guestToken: process.env.REACT_APP_GUEST_TOKEN
};

